import React, {
  FunctionComponent,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import MoreIcon from "@material-ui/icons/MoreVert";
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  Grid,
  Badge,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import Avatar from "@material-ui/core/Avatar";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { MobileMenu } from "./MobileMenu";
import { ProfileMenu } from "./ProfileMenu";
import { useStore } from "../../store/index";
import logo from "../../assets/images/webappLogo.jpg";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";
import { api } from "../../api";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  ffcTitle: {
    fontWeight: "bolder",
    padding: theme.spacing(2, 2),
    backgroundColor: theme.palette.primary.main,
  },
  navbarBgColor: {
    textDecoration: "none",
    backgroundColor: "#fff",
  },
  clientAdminLabel: {
    fontSize: "1.2em",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#fff",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
  },
}));

export const Navbar = () => {
  const classes = useStyles();

  const [user, { logout }] = useStore("auth", "user");
  const [signOutFlag, setSignOutFlag] = useState(false);
  const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
    (props, ref) => <RouterLink innerRef={ref} {...props} />
  );
  // const [dropdownMenuAnchor, setDropdownMenuAnchor] = useState<{
  //   target: Element | null;
  //   menuTitle: string | null;
  // }>({ target: null, menuTitle: null });

  const [profileMenu, setProfileMenu] = useState<Element | null>(null);
  const [subProfileMenu, setSubProfileMenu] = useState<Element | null>(null);
  const [moreIconMenu, setMoreIconMenu] = useState<Element | null>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState<Element | null>(
    null
  );
  const [permissionFlag, setPermissionFlag] = useState<boolean>(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [badgeOpen, setBadgeOpen] = useState<boolean>(true);
  const isMenuOpen = Boolean(subProfileMenu);
  const isMobileMenuOpen = Boolean(moreIconMenu);
  const notificationPermission = user.permissions.find(
    (permission: any) => permission.permission_id === 1
  );

  useEffect(() => {
    if (notificationPermission || user.is_super_admin === true) {
      try {
        const interval = setInterval(async () => {
          const notificationResult = await api.get(
            `notification//terminal-services-status`
          );
          const count = localStorage.getItem("notificationCount");
          if (
            notificationResult.message ===
            "You are not authorized for this action"
          ) {
            setPermissionFlag(false);
          } else {
            setPermissionFlag(true);
            if (
              notificationResult.find((i: any) =>
                i.services.find((j: any) => j.error === true)
              ) !== undefined
            ) {
              setErrorFlag(true);
              setBadgeOpen(false);
              if (isPopoverOpen === false && count === "false") {
                localStorage.setItem("notificationCount", "true");
                setIsPopoverOpen(true);
              }
            }
          }
        }, 10000);
        return () => clearInterval(interval);
      } catch (e) {
        console.log("error..", e);
      }
    }
  }, []);

  const handleProfileMenuClose = () => {
    setProfileMenu(null);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
    setMoreIconMenu(null);
  };

  const handleMenuClose = () => {
    setSubProfileMenu(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: SyntheticEvent) => {
    setMobileMoreAnchorEl(event.currentTarget);
    setMoreIconMenu(event.currentTarget);
  };
  const ProfileHandleClick = (event: SyntheticEvent) => {
    setProfileMenu(event.currentTarget);
  };

  const signOut = async () => {
    await logout();
    localStorage.clear();
    window.location.reload();
  };
  return (
    <div>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar disableGutters>
          <Grid container alignItems="center">
            <Grid
              item
              className={classes.navbarBgColor}
              component={NavLink}
              to="/"
            >
              {/* <Typography
                  className={classes.ffcTitle}
                  variant="h3"
                  color="secondary"
                >
                  FFC
                </Typography> */}
              <img src={logo} alt="Logo" />
            </Grid>
            <Grid item className={classes.sectionDesktop} xs>
              <Grid container justify="flex-end">
                {/* <Grid item> */}
                {/* <Grid container>
                      {menuSchema.map(item => {
                        const mainMenuItem = item.submenuItems ? (
                          <Button
                            onClick={e =>
                              setDropdownMenuAnchor({
                                target: e.currentTarget,
                                menuTitle: item.title
                              })
                            }
                          >
                            {item.title}
                            {item.submenuItems ? (
                              <ArrowDown color="secondary" />
                            ) : null}
                          </Button>
                        ) : (
                          <Button component={NavLink} to={item.link}>
                            {item.title}
                          </Button>
                        );
                        return (
                          <Grid key={item.title} item>
                            {mainMenuItem}
                            {item.submenuItems ? (
                              <Menu
                              getContentAnchorEl={null}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                              }}
                              anchorEl={dropdownMenuAnchor.target}
                                keepMounted
                                open={
                                  dropdownMenuAnchor.menuTitle === item.title
                                }
                                onClose={() =>
                                  setDropdownMenuAnchor({
                                    target: null,
                                    menuTitle: null
                                  })
                                }
                              >
                                {item.submenuItems.map(item => (
                                  <MenuItem
                                    key={item.title}
                                    onClick={() =>
                                      setDropdownMenuAnchor({
                                        target: null,
                                        menuTitle: null
                                      })
                                    }
                                    component={NavLink}
                                    to={item.link}
                                  >
                                    {item.title}
                                  </MenuItem>
                                ))}
                              </Menu>
                            ) : null}
                          </Grid>
                        );
                      })}
                    </Grid> */}
                {/* </Grid> */}

                {permissionFlag === true ? (
                  <Grid item>
                    <Button
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      component={NavLink}
                      to={`/posServices`}
                      onClick={() => {
                        setBadgeOpen(true);
                      }}
                      style={{
                        textAlign: "right",
                        backgroundColor: "#fff",
                        color: "#2e3191",
                      }}
                    >
                      <Badge
                        color="error"
                        badgeContent={1}
                        invisible={badgeOpen}
                        variant="dot"
                      >
                        <NotificationImportantIcon
                          color="primary"
                          style={{
                            fontSize: "3em",
                            color: errorFlag ? "red" : "",
                          }}
                        />
                      </Badge>
                    </Button>
                  </Grid>
                ) : (
                  ""
                )}

                <div>
                  <Popover
                    open={isPopoverOpen}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        paddingTop: "-5em",
                        width: "395px",
                        height: "103px",
                      }}
                    >
                      <Button
                        onClick={() => {
                          localStorage.setItem("notificationCount", "false");
                          setIsPopoverOpen(false);
                        }}
                        style={{
                          color: "black",
                          backgroundColor: "white",
                          marginLeft: "25em",
                        }}
                      >
                        <CloseIcon />
                      </Button>
                      <Typography
                        style={{
                          fontSize: "18px",
                          paddingLeft: "1em",
                          paddingRight: "1em",
                          paddingBottom: "1em",
                        }}
                      >
                        Error Alert !!! Plz check terminal notifications...
                      </Typography>
                    </div>
                  </Popover>
                </div>
                <Grid item>
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={ProfileHandleClick}
                    style={{
                      textAlign: "right",
                      backgroundColor: "#fff",
                      color: "#2e3191",
                    }}
                  >
                    <Grid container spacing={1} alignItems="center">
                      <Grid item>
                        <Avatar>A</Avatar>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.clientAdminLabel}>
                          {user.full_name}
                        </Typography>
                      </Grid>
                    </Grid>
                    <ArrowDown color="secondary" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              // style={{ color: "blue" }}
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      <MobileMenu
        mobileMoreAnchorEl={mobileMoreAnchorEl}
        isMobileMenuOpen={isMobileMenuOpen}
        handleMobileMenuClose={handleMobileMenuClose}
      />
      <ProfileMenu
        handleMenuClose={handleMenuClose}
        isMenuOpen={isMenuOpen}
        subProfileMenu={subProfileMenu}
      />
      <Menu
        anchorEl={profileMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(profileMenu)}
        onClose={handleProfileMenuClose}
      >
        <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
        <MenuItem onClick={handleProfileMenuClose}>My account</MenuItem>
        <MenuItem onClick={signOut}>Sign Out</MenuItem>
      </Menu>
    </div>
  );
};
